export default{
  setUser ({commit, state}, user) {
    commit('setUser', user)
  },
  setSessionId({commit},sessionId){

  }

}



// WEBPACK FOOTER //
// ./src/store/actions.js